import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';
import { readMetaTag } from '@rsos/utils/metaTags';

const feAppName = readMetaTag('fe-app-name');
const CENTRAL_STATION = 'central_station';

const appName = feAppName === CENTRAL_STATION ? 'CSP' : 'RSP';

const LEGACY_CATEGORY = 'Data Location';

const ALERT_LOCATION_EVENT_NAMES = {
  COPY_LAT_LONG: 'map_copy_alert_lat_long',
  COPY_ADDRESS: 'map_copy_alert_address',
};

export const trackCopyAlertLocation = (selectedAlertID, irpVersion) => {
  gspx.trackEvent({
    name: ALERT_LOCATION_EVENT_NAMES.COPY_LAT_LONG,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MAP,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `Copy Alert Lat and Long in ${appName}`,
      Category: 'Location Card Copy coordinates',
      'Launched date': new Date(),
      irpVersion,
      appName,
    },
    entities: {
      alert_id: selectedAlertID,
    },
  });
};

export const trackCopyAlertAddress = (selectedAlertID, irpVersion) => {
  gspx.trackEvent({
    name: ALERT_LOCATION_EVENT_NAMES.COPY_ADDRESS,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MAP,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `Copy Alert Location address in ${appName}`,
      Category: 'Location Card Copy coordinates',
      'Launched date': new Date(),
      irpVersion,
      appName,
    },
    entities: {
      alert_id: selectedAlertID,
    },
  });
};
